import { connect, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import InternalContainer from '../../layout/containers/Internal';
import { Loader } from '../../../common/components';
import InsurerSmsConfirmationMessageForm from '../components/InsurerSmsConfirmationMessageForm/InsurerSmsConfirmationMessageForm';
import { actions } from '../redux/ProductReducer';
import { Tab, Tabs } from 'react-bootstrap';

const sanitize = (smsMessage) => {
  return smsMessage.replace(/(\\)/g, '');
};

const SmsConfirmationContainer = ({
  params,
  getProduct,
  getInsurerSmsConfirmationMessage,
  updateSmsConfirmationMessage,
}) => {
  const { productId, insurerId } = params;
  const isSchemeGroup = ['FreeSpirit', 'Free2Travel'].includes(insurerId);
  const {
    product,
    isLoading,
    topLevelArea: { singleSchemeMeta, annualSchemeMeta },
  } = useSelector((state) => state.productManagement);

  const singleSchemeList = singleSchemeMeta?.[insurerId]?.schemes;
  const annualSchemeList = annualSchemeMeta?.[insurerId]?.schemes;
  const singleSchemeSmsMessage = singleSchemeMeta?.[insurerId]?.parameters?.smsMessage;
  const annualSchemeSmsMessage = annualSchemeMeta?.[insurerId]?.parameters?.smsMessage;

  const currentProductId = product?.data?.id;
  useEffect(
    () => {
      if (!currentProductId || currentProductId !== productId) {
        getProduct(productId);
      }
    },
    [productId, currentProductId, getProduct],
  );
  useEffect(
    () => {
      getInsurerSmsConfirmationMessage(insurerId, isSchemeGroup);
    },
    [insurerId, isSchemeGroup, getInsurerSmsConfirmationMessage],
  );

  const update = (formValues) => {
    const sms = formValues.data.attributes.metadata.sms_message;
    const schemesToUpdate = formValues?.meta?.schemes?.filter((scheme) => {
      return scheme.enabled;
    });
    const values = {
      ...formValues,
      data: {
        attributes: {
          metadata: {
            sms_message: sanitize(sms),
          },
        },
      },
      meta: {
        ...formValues.meta,
        schemes: schemesToUpdate,
      },
    };
    return updateSmsConfirmationMessage(values, isSchemeGroup);
  };

  if (
    isLoading ||
    (singleSchemeSmsMessage === undefined && annualSchemeSmsMessage === undefined)
  ) {
    return (
      <InternalContainer title={'SMS Confirmation'}>
        <Loader />
      </InternalContainer>
    );
  }

  const singleValues = {
    data: {
      attributes: {
        metadata: {
          sms_message: singleSchemeSmsMessage,
        },
      },
    },
    meta: {
      schemes: singleSchemeList?.map((scheme) => ({
        ...scheme,
        update: false,
      })),
    },
  };
  const annualValues = {
    data: {
      attributes: {
        metadata: {
          sms_message: annualSchemeSmsMessage,
        },
      },
    },
    meta: {
      schemes: annualSchemeList?.map((scheme) => ({
        ...scheme,
        update: false,
      })),
    },
  };

  return (
    <InternalContainer title={'SMS Confirmation'}>
      <Tabs defaultActiveKey={1} id="uncontrolled-tab-example" unmountOnExit={true}>
        <Tab eventKey={1} title="Single Trip">
          <InsurerSmsConfirmationMessageForm
            values={singleValues}
            formName={'SingleSMSConfirmationMessage'}
            onUpdate={update}
          />
        </Tab>
        <Tab eventKey={2} title="Annual Multi Trip">
          <InsurerSmsConfirmationMessageForm
            values={annualValues}
            formName={'AnnualSMSConfirmationMessage'}
            onUpdate={update}
          />
        </Tab>
      </Tabs>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    getProduct: actions.getProduct,
    getInsurerSmsConfirmationMessage: actions.getInsurerSmsConfirmationMessage,
    updateSmsConfirmationMessage: actions.updateSmsConfirmationMessage,
  },
)(SmsConfirmationContainer);
